<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="课程分类">
        <Cascader
          :data="catagoris"
          :change-on-select="true"
          trigger="hover"
          v-model="course_classify_ids"
          style="width: 200px"
        ></Cascader>
      </Form-item>
      <Form-item label="课程类型">
        <Select
          v-model="searchCondition.course_type"
          clearable
          style="width: 200px"
        >
          <Option v-for="item in courseTypes" :value="item.key" :key="item.key">
            {{ item.value }}
          </Option>
        </Select>
      </Form-item>
      <Form-item label="课程状态">
        <Select v-model="searchCondition.status" clearable style="width: 200px">
          <Option
            v-for="item in courseStatus"
            :value="item.key"
            :key="item.key"
          >
            {{ item.value }}
          </Option>
        </Select>
      </Form-item>

      <Form-item label="可见性">
        <Select
          v-model="searchCondition.is_hidden"
          clearable
          style="width: 200px"
        >
          <Option :value="1">隐藏</Option>
          <Option :value="0">显示</Option>
        </Select>
      </Form-item>

      <Form-item label="创建时间">
        <Date-picker
          :editable="false"
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width: 280px"
          @on-change="onDateRange"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Date-picker>
      </Form-item>
      <div>
        <Form-item label="课程名称">
          <Input
            style="width: 200px"
            placeholder="请输入课程名称关键字"
            v-model="searchCondition.keywords"
            clearable
            @keydown.native.enter="search(1)"
          />
        </Form-item>
        <Form-item label="是否分班">
          <Select
            v-model="searchCondition.is_divide_class"
            clearable
            style="width: 200px"
          >
            <Option value="1">是</Option>
            <Option value="0">否</Option>
          </Select>
        </Form-item>
        <Form-item class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="search(1)">搜索</Button>
            <Button icon="md-undo" @click="search(0)">重置</Button>
          </div>
        </Form-item>
      </div>
    </Form>
    <Button
      v-if="teacherID == 0"
      type="primary"
      @click="showCreateCourse = true"
    >
      新增课程
    </Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/course/basis/index"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="post"
      >
        <template slot-scope="{ row }" slot="c1">
          {{ row.title }}
          <br v-if="row.class_id && row.course_type == 4" />
          <Button
            type="text"
            size="small"
            v-if="row.class_id && row.course_type == 4"
          >
            下载回放
          </Button>
          <br v-if="row.class_id && row.course_type == 4" />
          <Button
            type="text"
            size="small"
            v-if="row.class_id && row.course_type == 4"
            @click="copyShareLink(row)"
          >
            复制分享链接
          </Button>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            @click="setStatus(row.id, 1)"
            v-if="row.status != 1"
          >
            上架-
          </Button>
          <Button
            type="text"
            size="small"
            @click="setStatus(row.id, 2)"
            v-if="row.status == 1"
          >
            下架-
          </Button>
          <Button
            type="text"
            size="small"
            @click="setTop(row.id, 1)"
            v-if="row.is_top == 0"
          >
            置顶-
          </Button>
          <Button
            type="text"
            size="small"
            @click="setTop(row.id, 0)"
            v-if="row.is_top == 1"
          >
            取消置顶-
          </Button>
          <Button
            type="text"
            size="small"
            :to="{ name: 'CoursePlan', query: { id: row.id } }"
            :disabled="row.course_type == 4 || row.course_type == 9"
          >
            课程大纲-
          </Button>
          <Button
            type="text"
            size="small"
            :to="{
              name: 'CourseEdit',
              query: { id: row.id, type: row.course_type },
            }"
          >
            编辑-
          </Button>
          <Button
            type="text"
            size="small"
            @click="deleteCourse(row.id)"
            :disabled="row.status == 1"
          >
            删除-
          </Button>
          <Button
            type="text"
            size="small"
            @click="toggleHidden(row.id, row.is_hidden)"
          >
            <span v-if="!row.is_hidden">隐藏</span>
            <span v-if="row.is_hidden">显示</span>
          </Button>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchSetStatus(1)"
          >
            上架
          </Button>
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchSetStatus(2)"
          >
            下架
          </Button>
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchDelete"
          >
            删除
          </Button>
        </template>
      </Grid>
    </div>
    <Modal
      v-model="showCreateCourse"
      title="新增课程"
      width="800"
      scrollable
      footer-hide
    >
      <ul class="course-select">
        <li class="course-select-item" @click="createCourse(2)">
          <div class="course-select-title">
            大班课
            <span class="course-select-type">直播</span>
          </div>
          <div>
            主要适用于单向宣讲为主的课程，一对多，不需要或者很少需要互动。
          </div>
        </li>
        <!-- <li class="course-select-item" @click="createCourse(3)">
          <div class="course-select-title">
            小班课
            <span class="course-select-type">直播</span>
          </div>
          <div>每班最多容纳312个学生，适用于互动较多的课程，属于精品课。</div>
        </li> -->
        <li class="course-select-item" @click="createCourse(4)">
          <div class="course-select-title">
            公开课
            <span class="course-select-type">直播</span>
          </div>
          <div>
            无需注册和登录，点开链接就能看的免费课程，一般用于宣传、引流。
          </div>
        </li>
        <li class="course-select-item" @click="createCourse(5)">
          <div class="course-select-title">点播课</div>
          <div>无需实时互动的视频课程，需上传对应的视频，可反复观看。</div>
        </li>
        <li class="course-select-item" @click="createCourse(8)">
          <div class="course-select-title">音频课</div>
          <div>适用于以音频为主的课程，需上传对应的音频，可反复收听。</div>
        </li>
        <li class="course-select-item" @click="createCourse(10)">
          <div class="course-select-title">图文课</div>
          <div>适用于以图文为主的课程，需上传对应的图文，可反复观看。</div>
        </li>
        <li class="course-select-item" @click="createCourse(7)">
          <div class="course-select-title">面授课</div>
          <div>适用于线下授课的课程，线上可报名缴费，线下授课。</div>
        </li>
        <li class="course-select-item" @click="createCourse(9)">
          <div class="course-select-title">系统课</div>
          <div>适用于多节课程打包售卖，比如有进阶关系的系列课程。</div>
        </li>
      </ul>
    </Modal>
  </div>
</template>
<script>
const buildConfig = require("../../build/" + process.env.BUILD_ENV + ".js");
import * as enums from "../../utils/enums";

export default {
  name: "CourseList",
  props: {
    teacherID: {
      default: "",
    },
  },
  data() {
    return {
      courseTypes: enums.CouseType.getOptions(),
      courseStatus: enums.CourseStatus.getOptions(),
      start_created: "",
      finish_created: "",
      course_classify_name: "",
      showSelectCatagory: false,
      showCreateCourse: false,
      columns: [
        {
          title: "课程名称",
          slot: "c1",
          minWidth: 200,
        },
        {
          title: "所属分类",
          key: "classify_title",
          width: 120,
          align: "center",
        },
        {
          title: "课程类型",
          key: "course_type_name",
          width: 100,
          align: "center",
        },
        {
          title: "是否分班",
          key: "is_divide_class_name",
          width: 100,
          align: "center",
        },
        {
          title: "上架状态",
          key: "status_name",
          width: 100,
          align: "center",
        },
        {
          title: "创建人",
          key: "created_name",
          width: 100,
          align: "center",
        },
        {
          title: "创建时间",
          key: "created_at",
          width: 160,
          align: "center",
        },
        {
          title: "更新时间",
          key: "updated_at_name",
          width: 160,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center",
          fixed: "right",
        },
      ],
      searchCondition: {
        course_classify_id: 0,
        teacher_id: this.teacherID,
        course_type: "",
        status: "",
        keywords_type: "title",
        keywords: "",
        start_created_at: "",
        finish_created_at: "",
        is_divide_class: "",
        is_hidden: "",
      },
      selectList: [],
      catagoris: [],
      course_classify_ids: [],
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    this.catagoris = catagoris;
  },
  methods: {
    copyShareLink(row) {
      const baseUrl = buildConfig.BASE_URL;
      const id = row.id;
      const type = row.course_type;
      navigator.clipboard
        .writeText(`${baseUrl}/course/${id}/cloud_class?course_type=${type}`)
        .then(() => {
          this.$Message.success("复制成功");
        });
    },
    onDateRange(range) {
      this.searchCondition.start_created_at = range[0];
      this.searchCondition.finish_created_at = range[1];
    },
    rowsFormatter(rows) {
      rows.forEach((i) => {
        i.course_type_name = enums.CouseType.getValue(i.course_type);
        i.status_name = enums.CourseStatus.getValue(i.status);
        i.updated_at_name = this.$pub.timestampToTime(i.updated_at);
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.is_divide_class_name = i.is_divide_class == 1 ? "是" : "否";
      });
    },
    search(flag) {
      if (flag == 0) {
        this.$refs.formDate.handleClear();
        this.searchCondition.course_classify_id = 0;
        this.searchCondition.course_type = "";
        this.searchCondition.status = "";
        this.searchCondition.keywords = "";
        this.searchCondition.start_created_at = "";
        this.searchCondition.finish_created_at = "";
        this.searchCondition.is_divide_class = "";
        this.searchCondition.is_hidden = "";
        this.start_created = "";
        this.finish_created = "";
        this.course_classify_name = "";
        this.course_classify_ids = [];
      } else {
        if (this.course_classify_ids.length > 0) {
          this.searchCondition.course_classify_id =
            this.course_classify_ids[this.course_classify_ids.length - 1];
        } else {
          this.searchCondition.course_classify_id = 0;
        }
      }
      this.$refs.grid.searchRefresh();
      this.selectList = [];
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    async confirmSelectCatagory() {
      let items = await this.$refs.tree.getSelectedItems();
      this.showSelectCatagory = false;
      if (items.length == 0) {
        this.course_classify_name = "";
        this.searchCondition.course_classify_id = "";
      } else {
        let item = items[0];
        this.course_classify_name = item.name;
        this.searchCondition.course_classify_id = item.id;
      }
    },

    async getStandardRoomJumpUrl(id, classId, userId, userName) {
      const result = await this.$http.get("/api/course/class_url", {
        id,
        classId,
        userId,
        userName,
      });

      if (result.standardRoomJumpUrl) {
        window.open(result.standardRoomJumpUrl, "_blank");
      }
    },

    async setStatus(id, status, isBatch = false) {
      if (status == 2) {
        await this.$promiseConfirm(
          "下架后，将无法进入该课程详情界面，是否确认？"
        );
      }
      await this.$http.put("/api/course/basis/selves", {
        id: id,
        status: status,
      });
      this.$refs.grid.refresh();
      this.selectList = [];
      if (status == 1 && !isBatch) {
        this.$Message.success("上架成功");
      }
    },
    async batchSetStatus(status) {
      let ids = [];
      this.selectList.forEach((c) => {
        ids.push(c.id);
      });
      let id = ids.join(",");
      await this.setStatus(id, status, true);
      this.$Message.success("批量操作成功");
    },
    async setTop(id, isTop) {
      await this.$http.put("/api/course/basis/top", {
        id: id,
        is_top: isTop,
      });
      this.$Message.success("操作成功");
      this.$refs.grid.refresh();
    },
    async toggleHidden(id, isHidden) {
      await this.$http.put("/api/course/basis/hidden", {
        id,
        is_hidden: !isHidden,
      });
      this.$Message.success("操作成功");
      this.$refs.grid.refresh();
    },
    async deleteCourse(id) {
      await this.$promiseConfirm("删除后，员工将无法查看该课程。是否确认？");
      await this.$http.delete("/api/course/basis/" + id, {});
      this.$refs.grid.refresh();
    },
    async batchDelete() {
      let ids = [];
      this.selectList.forEach((c) => {
        ids.push(c.id);
      });
      let id = ids.join(",");
      await this.deleteCourse(id);
      this.selectList = [];
    },
    createCourse(courseType) {
      this.showCreateCourse = false;
      this.$router.push({ name: "CourseEdit", query: { type: courseType } });
    },
  },
};
</script>
<style>
.course-select {
  overflow: hidden;
}

.course-select-item {
  float: left;
  width: 176px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  height: 240px;
  color: #7f6697;
  margin: 8px;
  cursor: pointer;
  padding: 43px 28px;
  text-align: justify;
}

.course-select-title {
  color: black;
  font-size: 16px;
  text-align: center;
  position: relative;
  margin-bottom: 30px;
}

.course-select-type {
  position: absolute;
  color: red;
  font-size: 12px;
  top: -5px;
}
</style>
